module.exports = __webpack_public_path__ + "img/anti-alias-highlight-edges.c641e0d3.png";